// react
import React, { Fragment, useEffect, useState } from 'react';
// styles
import styles from './index.module.scss';
// redux
import { useSelector } from 'react-redux';
// smallBtn
import { BtnSmall } from '../../btns/btnSmall/index';
import { DeleteBtn } from '../../btns/DeleteBtn/index';
// services getRole
import { getRoleService } from '../../../services/adminService';
/***************************************************************************/
/* Name : StudentItem React Component */
/***************************************************************************/
const StudentItem = React.memo((props) => {
  const api_url = useSelector((state) => state.ui.api_url);
  // states
  // privilege
  const [role, setRole] = useState('');
  const [studentName, setStudentName] = useState('الاسم');
  // useEffect
  useEffect(() => {
    (async () => {
      // get role
      const { role } = await getRoleService(props.studentData.role);
      setRole(role);
      if (props.studentData.studentName !== 'الاسم') {
        const nameArray = props.studentData.studentName.split(' ');
        setStudentName(
          nameArray[0] +
            ' ' +
            nameArray[1] +
            ' ' +
            nameArray[2] +
            ' ' +
            nameArray[3]
        );
      }
    })();
  }, []);
  /***************************************************************************/
  /* Name : deleteHandler */
  /* Description : deleteHandler */
  /***************************************************************************/
  const deleteHandler = () => {
    props.onDeleteHandler(props.studentData._id, props.studentData.studentName);
  };
  /***************************************************************************/
  /* Name : print Student Paper */
  /* Description : print Student Paper */
  /***************************************************************************/
  const printStudentPaper = () => {
    window.location.href = `${api_url}/api/v1/students/getAdmissionForm/${props.studentData._id}`;
  };
  return (
    <Fragment>
      <div className={styles['student-item']}>
        <div className={styles['student-item__info']}>
          <span>{studentName}</span>
        </div>
        <div className={styles['student-item__sep']}></div>
        {
          <div>
            <div className={styles['student-item__info']}>
              <span>{props.studentData.nationalID}</span>
            </div>
          </div>
        }
        <div className={styles['student-item__sep']}></div>
        {
          <div>
            <div className={styles['student-item__info']}>
              <span>{props.studentData.phoneNumber}</span>
            </div>
          </div>
        }
        <div className={styles['student-item__sep']}></div>
        {
          <div>
            <div className={styles['student-item__info']}>
              <span>{props.studentData.college}</span>
            </div>
          </div>
        }
        <div className={styles['student-item__sep']}></div>
        {props.studentData.info !== '' && (
          <div>
            <div className={styles['student-item__info']}>
              <span>{props.studentData.info}</span>
            </div>
          </div>
        )}
        {props.studentData.info === '' && (
          <div className={styles['student-item__info']}>
            {props.studentData.isComplete ? ( // if true
              <span className={styles['confirmed']}>مكتلمة 🟢</span>
            ) : (
              // if false
              <span className={styles['not-confirmed']}>غير مكتملة 🔴</span>
            )}
          </div>
        )}
        {(role === 'SUPERADMIN' || role === 'SUPPORT') &&
          role !== 'NOT' &&
          props.studentData.studentName !== 'الاسم' && (
            <DeleteBtn onPress={deleteHandler} />
          )}
        {props.studentData.info === '' && props.studentData.isComplete && (
          <Fragment>
            <BtnSmall title={'تنزيل طلب التقديم'} onClick={printStudentPaper} />
          </Fragment>
        )}
      </div>
    </Fragment>
  );
});

export { StudentItem };
